// extracted by mini-css-extract-plugin
export default {"logoInfoWrapper":"LogoInfo_logoInfoWrapper__vlY5t","logo_content":"LogoInfo_logo_content__U3o4w","logo":"LogoInfo_logo__kPeNp"};